/**
 * Inspektionsdaten actions.
 * @module actions/inspektionsdaten/inspektionsdaten
 */

import { merge } from "lodash";

import { GET_INSPEKTIONSDATEN } from "../../constants/ActionTypes";
import { parseParams } from "../../helpers/url/url";
import { parsePrependParams } from "../../helpers/Api/ParsePrependParams";

/**
 * Get inspektionsdaten.
 * @function getInspektionsdaten
 * @params {Number} id Id of the project.
 * @params {Number} bucket Bucket of the project.
 * @params {Object} filters Object with filters.
 * @returns {Object} Get inspektionsdaten action.
 */
export function getInspektionsdaten(
  id,
  bucket,
  filters,
  scales,
  units,
  typeDashboard
) {
  return {
    type: GET_INSPEKTIONSDATEN,
    request: {
      op: "get",
      path: `inspektionsdaten/${id}`,
      params: merge(
        parseParams(filters),
        parsePrependParams(scales, "scale_"),
        parsePrependParams(units, "unit_"),
        bucket ? { bucket } : {},
        { typeDashboard: typeDashboard }
      )
    }
  };
}
